var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegularCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47449 2.25C7.72877 6.01275 7.10165 9.14837 3.966 12.9111C3.49756 13.4732 3.14109 14.0773 2.87778 14.7067C1.37848 18.2903 2.89911 22.6927 3.96599 24.8265M21.5255 2.25C20.2712 6.01275 20.8984 9.14837 24.034 12.9111C24.4877 13.4556 24.8364 14.0394 25.0971 14.6475C26.6383 18.2416 25.1068 22.681 24.034 24.8265M14.0472 9.7755V9.14837M14 22.318L14.0826 21.657C14.3936 19.1685 16.5091 17.301 19.017 17.301V17.301M14 22.318V24.8265M14 22.318L13.9173 21.657C13.6063 19.1685 11.4908 17.301 8.98298 17.301V17.301",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularCycle);
export default __webpack_public_path__ + "static/media/regular_cycle.3bea35a8c42392c875aa207ef47c8523.svg";
export { ForwardRef as ReactComponent };